import { translate } from '../../i18n/index.js';
import { Link } from 'react-router-dom';

export function LandingFooter() {
  return (
    <footer className="af-shell af-landing-footer" id="contact">
      <div className="af-landing-footer-contact">
        <strong>
          {translate('components.landing.landing_footer.landing_footer.strong.heading')}
        </strong>
        <a href="mailto:support@atomfit.cz">
          {translate('components.landing.landing_footer.landing_footer.a.label')}
        </a>
        <a href="tel:+420774102343">{'+420 774 102 343'}</a>
      </div>
      <div
        className="af-landing-footer-social"
        aria-label={translate(
          'components.landing.landing_footer.landing_footer.div_landing_footer_social.aria_label_content',
        )}
      >
        <strong>
          {translate('components.landing.landing_footer.landing_footer.strong.heading_2')}
        </strong>
        <div className="af-landing-footer-social-icons">
          <a
            className="af-social-icon"
            href="https://www.facebook.com/atomfitcz"
            target="_blank"
            rel="noreferrer"
            aria-label={translate(
              'components.landing.landing_footer.landing_footer.a_social_icon.aria_label_content',
            )}
          >
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <path
                className="af-social-icon-brand"
                transform="translate(8 8) scale(1.3333)"
                d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.099 4.388 23.094 10.125 24v-8.438H7.078v-3.49h3.047V9.413c0-3.024 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.973h-1.513c-1.49 0-1.956.931-1.956 1.887v2.262h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.099 24 12.073z"
              />
            </svg>
          </a>
          <a
            className="af-social-icon"
            href="https://www.instagram.com/atomfit_cz/"
            target="_blank"
            rel="noreferrer"
            aria-label={translate(
              'components.landing.landing_footer.landing_footer.a_social_icon.aria_label_content_2',
            )}
          >
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <path
                className="af-social-icon-brand"
                transform="translate(8 8) scale(1.3333)"
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.848s-.012 3.584-.07 4.849c-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.849.07s-3.584-.012-4.849-.07c-3.26-.149-4.771-1.699-4.919-4.92-.058-1.264-.07-1.644-.07-4.848s.013-3.583.071-4.849c.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.848-.069zM12 0C8.741 0 8.332.014 7.052.072 2.695.272.273 2.69.073 7.052.014 8.332 0 8.741 0 12s.014 3.668.072 4.948c.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.742 24 12 24s3.668-.014 4.948-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948s-.014-3.668-.072-4.948C23.728 2.694 21.307.273 16.949.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-10.405a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"
              />
            </svg>
          </a>
          <a
            className="af-social-icon"
            href="https://www.youtube.com/@atomfit_cz"
            target="_blank"
            rel="noreferrer"
            aria-label={translate(
              'components.landing.landing_footer.landing_footer.a_social_icon.aria_label_content_3',
            )}
          >
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <path
                className="af-social-icon-brand"
                transform="translate(6 6) scale(1.5)"
                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.017 3.017 0 0 0 2.121 2.136c1.872.505 9.377.505 9.377.505s7.505 0 9.377-.505a3.016 3.016 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12z"
              />
            </svg>
          </a>
        </div>
      </div>
      <span className="af-landing-footer-links">
        <Link to="/terms">
          {translate('components.landing.landing_footer.landing_footer.link.terms')}
        </Link>
        <Link to="/privacy">
          {translate('components.landing.landing_footer.landing_footer.link.privacy')}
        </Link>
      </span>
    </footer>
  );
}
